import React from 'react'

const testimonialRoutes = [
   
    {
        path: '/testimonials/add',
        component: React.lazy(() => import('./Add')),
    } ,  
    {
        path: '/testimonials/update/:id',
        component: React.lazy(() => import('./Update')),
    } ,   
    
    {
        path: '/testimonials',
        component: React.lazy(() => import('./Index')),
    } 
]

export default testimonialRoutes
